/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bell_Empty_HintInputs */

const en_bell_empty_hint = /** @type {(inputs: Bell_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What asks for your action shows up here as soon as it reaches you.`)
};

/**
* | output |
* | --- |
* | "What asks for your action shows up here as soon as it reaches you." |
*
* @param {Bell_Empty_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_empty_hint = /** @type {((inputs?: Bell_Empty_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Empty_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_empty_hint(inputs)
});